angular.module('mtic.components.modules.gr78').
directive('lmapSidepanelAgenda', function(
  $log,
  $q,
  language,
  EventManager,
  StudentDataService,
  PanelStateService,
  $timeout
) {
  return {

    templateUrl: 'template.html',
    scope: {
      'moduleMapData': '='
    },

    link: function(scope, element) {
      var eventManager = new EventManager('lmapSidepanelAgendaNode', scope)      
      moment.locale(language.getCurrentSelectedLanguage());
      scope.language = language;
      var selectedResourceId = -1;
      var studentAgendaItemHashMap = {};
      scope.loadingStatus = {
        done: false,
        error: false
      }
      scope.agendas = [];
      scope.active_agenda = {};
      scope.databaseResource = {};
      scope.resourceMapping = {};
      scope.agenda_progress = {
        total : 0,
        score : 0
      }

      scope.moment = moment;

      scope.getName = function(resourceId) {
        var name = '#(N/A)';
        if(scope.resourceMapping[resourceId]){
          var resource = scope.resourceMapping[resourceId];
          /*
           if(resource.slug && (resource.slug.indexOf("_m0")>1||resource.slug.indexOf("_m4")>1)){
            name = language.get(resource.slug+'_short');
          }else{
            name = language.get(resource.slug);
          }*/
          
         name = language.get(resource.slug);

          if (!name) {
            if (resource.name) {
              name = resource.name;
            } else {
              name = resource.slug;
            }
          }
        }

        return name;
      }



      scope.getIconCssClasses = function(resourceId) {
        var shape = '';
        var color = '';
        var resource = scope.resourceMapping[resourceId];
        if (resource) {
          color = 'color-bubble-icon-' + (resource.display.color ? resource.display.color : 'blue');
          if (resourceIsComplete(resourceId)) {
            shape = 'fa-check-circle';
          } else {
            shape = 'fa-circle-o';
          }
        }
        return shape + ' ' + color;
      }
      scope.selectAgenda = function(agenda) {
        // scope.active_agenda = agenda;
        if(agenda && agenda.id){
          //eventManager.broadcast('moduleview:agenda:selected', agenda);
          PanelStateService.setActiveAgenda(agenda.id);
        }
      }
      scope.onNodeClick = function(resourceId) {
        var resource = scope.resourceMapping[resourceId];
        var isLocked = isThisResourceLocked(resource);
        $log.debug('[[lmapSidepanelAgenda]] onNodeClick', resource, resourceId, isLocked)
        if(!isLocked && selectedResourceId === Number(resource.id)){
            eventManager.broadcast( 'module:open:resource', resource );
        }else
        if(resource){
            // var item_evt_info = {
            //   slug : resource.slug,
            //   id : resource.id
            // }
            eventManager.broadcast( 'module:select:resource', resource );
            eventManager.broadcast( 'module:center:resource', resource );
        }
      }
      scope.isSelected = function (resourceId) {
        return selectedResourceId === Number(resourceId);
      }
      scope.refresh = function(){
        eventManager.broadcast('agendapanel:refresh')
      }
      var isThisResourceLocked = function(resource) {
        var isLocked = resource.locked;
        switch(interpeteAgendaLockStatus()) {
          case 'unlock':
            return false;
          case 'lock':
            return true;
          default:
            return isLocked;
        }
      }
      var interpeteAgendaLockStatus = function(){
        if(scope.active_agenda.force_unlock === true) {
          return 'unlock';
        } else if(scope.active_agenda.force_unlock === false) {
          return 'lock';
        } else {
          return 'default';
        }
      }
      var resourceIsComplete = function(resourceId){
        var mapResource = scope.resourceMapping[resourceId];
        var studentAgendaItemResource = studentAgendaItemHashMap[resourceId];
        return (studentAgendaItemResource && studentAgendaItemResource.resource_completed) ||
        (mapResource.resourceState && mapResource.resourceState.complete)
      }
      var placeCustomInMap = function(resource){
        var parent_slug = resource.content.position_data.parent_slug;
        var index = Number(resource.content.position_data.index);
        // $log.log('scope.modulemapdata : ' , scope.moduleMapData)
        if(parent_slug === scope.moduleMapData.slug){
          scope.moduleMapData.resources.splice(index , 0 , resource)
          return;
        }

        scope.moduleMapData.resources.forEach(function(sub_mod){
          
          if(sub_mod.display && sub_mod.display.panel){
            if(sub_mod.slug === parent_slug){
              sub_mod.display.panel.splice(index, 0, resource);
              return;
            }
            sub_mod.display.panel.forEach(function(sub){
              checkResourceAndInsert(sub, resource);
            })
          }
        })
      }
      var checkResourceAndInsert = function(sub, resource){
        if(sub.sub){
          if(sub.slug === resource.content.position_data.parent_slug){
            sub.sub.splice(Number(resource.content.position_data.index) , 0 , resource);
          }else{
            sub.sub.forEach(function(sub_sub){              
              checkResourceAndInsert(sub_sub, resource);
            })
          }
        }
      }
      var checkIfResourcesAreInMapElseAttemptToGrab = function(agendaData){
        return $q.all(agendaData.map(function(agenda){
          return $q.all(agenda.resources.map(function(resourceId){
            if(!scope.resourceMapping[resourceId]) {
              // $log.log('lmap get custom : ', resourceId)
              return StudentDataService.getCustomResource(resourceId).then(function(resource) {
                scope.resourceMapping[resourceId] = resource;
                if(resource.content && resource.content.position_data){
                  placeCustomInMap(resource);
                }
                // $log.log('mapping custom : ', resource)
                return;
              })
            }else{
              return $q.resolve();
            }
          }))
        })).then(function() {
          return agendaData;
        })
      }
      var force_unlock_summatives = [];
      var calcProgress = function(agenda) {
        agenda.progress = {};
        agenda.progress.total = 0;
        agenda.progress.score = 0;
        agenda.resource_progress_map = {}
        studentAgendaItemHashMap = {};
        agenda.StudentAgendaItems.forEach(function(studentAgendaItem){
          studentAgendaItemHashMap[studentAgendaItem.resource_id] = studentAgendaItem;
        })
        agenda.resources.forEach(function(resourceId){
          var resource = scope.resourceMapping[resourceId];
          if(resource && resource.display)
          {
            if(resource.resource_type === "custom_resource"){
              agenda.progress.score = studentAgendaItemHashMap[resourceId] ? agenda.progress.score+1:agenda.progress.score;
              agenda.resource_progress_map[resource.slug] = studentAgendaItemHashMap[resourceId] ? true : false;
            }else if(!agenda.force_redo || (agenda.force_redo && studentAgendaItemHashMap[resource.id])){              
              agenda.progress.score += resource.complete ? 1 : 0;
              agenda.resource_progress_map[resource.slug] = resource.complete;    
            }else{              
              agenda.resource_progress_map[resource.slug] = false;
              if(resource.config && resource.config.assessment_type && ((agenda.force_redo && resource.complete) || agenda.force_unlock)){
                resource.locked = false;
                if(force_unlocked_list.indexOf(resource.slug) === -1){
                  force_unlocked_list.push(resource.slug)
                }
                resource.locked = false;
                eventManager.broadcast('unlock-item', resource.slug)
              }    
            }
              
            agenda.progress.total ++;
          }
        })
        agenda.progress.prop = agenda.progress.score / agenda.progress.total;
        // $log.log('agenda progress : ', agenda, studentAgendaItemHashMap)//, scope.resourceMapping)
      }

      var init = function(){
        scope.resourceMapping = {};
        scope.loadingStatus.done = false;
        scope.loadingStatus.error = false;
        return $q.all([
          $q(function(resolve){
            scope.moduleMapData.resources.forEach(function(moduleMap){
              moduleMap.children.forEach(function(resource){
                scope.resourceMapping[resource.id] = angular.copy(resource);
                if(resource.children){
                  resource.children.forEach(function(sub){
                    scope.resourceMapping[sub.id] = angular.copy(sub);
                  })
                }
              })
            })
            resolve();
          }),
          StudentDataService.getAgendas()
          ]).then(function(datas){
            return checkIfResourcesAreInMapElseAttemptToGrab(datas[1]);
          }).then(function(agendaData) {
            eventManager.broadcast('moduleview:agenda:loaded', agendaData);
            scope.agendas = agendaData;
            scope.agendas.sort(dateSort);
            // $log.log('got agendas : ', agendaData)
            scope.agendas.forEach(function(agenda){
              calcProgress(agenda);
            })
            var active_agenda_index = 0;
            if (PanelStateService.getActiveAgenda() !== undefined)
            {
              var target_id = PanelStateService.getActiveAgenda();
              for (var i = 0; i < agendaData.length; i ++)
              {
                if (agendaData[i].id === target_id)
                {
                  active_agenda_index = i;
                  break;
                }
              }
            }

            scope.active_agenda = agendaData[active_agenda_index];
            sendSummInfo();

            //eventManager.broadcast('moduleview:agenda:selected', agendaData[active_agenda_index]);
          }).then(function() {
            scope.loadingStatus.done = true;
            scope.loadingStatus.error = false;
          }).catch(function(err) {
            $log.error(err);
            scope.loadingStatus.done = true;
            scope.loadingStatus.error = true;
          });
      }

      function dateSort(a,b){
        if (Date.parse(a.date_close) < Date.parse(b.date_close)){
          return -1;
        }
        if (Date.parse(a.date_close) > Date.parse(b.date_close)){
          return 1;
        }
        return 0;
      }

      eventManager.listen('agendapanel:refresh', function(){
        init();
      })

      eventManager.listen('module:select:resource', function(e, resource) {
        selectedResourceId = Number(resource.id);
      })

      eventManager.listen('module:dismiss:focus', function(e, data) {
        selectedResourceId = -1;
      })
      //There must be a better way :thinking:
      eventManager.listen('moduleview:agenda:request', function(e) {
        //eventManager.broadcast('moduleview:agenda:selected', scope.active_agenda);
      })

      // eventManager.listen('moduleview:agenda:selected', function(e, agenda) {
      //   $log.log('is this ever triggered ? ')
      //   if (agenda && agenda !== null && 'StudentAgendaItems' in agenda && 'resources' in agenda) {
      //       calcProgress(agenda);
      //     }
      // })

      eventManager.listen('creating-items-done', function(){
        scope.agendas.forEach(function(agenda){
          calcProgress(agenda);
        })
      })

      var lockedSummativeList = [];
      var force_unlocked_list = [];
      scope.$watch("moduleMapData", function(){
        init();
      })

      function sendSummInfo(){
        // if(scope.moduleMapData.module_id === 28 || scope.moduleMapData.module_id === 2 || scope.moduleMapData.module_id === 321){
          var unlockedSummativeList = [];
          scope.agendas.forEach(function(agenda){
            agenda.resources.forEach(function(summ){
              unlockedSummativeList.push(scope.resourceMapping[summ].slug);
            })
          })
          $timeout(function(){
            eventManager.broadcast('got-c4-summative-data', {unlocked:unlockedSummativeList, force_unlock: force_unlocked_list});
          }, 500)
        // }        
      }

      scope.isReleventDiagLocked = function(resc){
          //console.log('should hide : ', scope.resourceMapping[resc].slug, lockedSummativeList.indexOf(scope.resourceMapping[resc].slug));
          return lockedSummativeList.indexOf(scope.resourceMapping[resc].slug) > -1;
      }

      // var dayRef = ['SUN','MON','TUE','WED','THU','FRI','SAT']
      // scope.getFormattedDateDay = function(date){
      //   var day = (new Date(Date.parse(date))).getDay()
      //   return dayRef[day]
      // }
      // scope.getFormattedDateDayNum = function(date){
      //   var day = (new Date(Date.parse(date))).getDate()
      //   return day;
      // } 
      // var monthRef = ['January','February','March','April','May','June','July',
      // 'August','September','October','November','December']
      // scope.getFormattedDateMonth = function(date){
      //   var date_parse = new Date(date);
      //   return date_parse.getFullYear() + ' ' + monthRef[date_parse.getMonth()];
      // }
      scope.getFormattedFullDate = function(date){
        return date.split('T')[0].split('-').join('/');
      }
      scope.isNewAgendaMonth = function(index){
        if(index === 0){
          return true
        }
        var date1 = new Date(Date.parse(scope.agendas[index].date_close));
        var date2 = new Date(Date.parse(scope.agendas[index-1].date_close));
        return date1.getFullYear() !== date2.getFullYear() || date1.getMonth() !== date2.getMonth();
      }

      scope.view_controller = {
        isStudentView: true,
        openSubMod: function(slug){
          // $log.log('opening sub mod:', slug)
          $timeout(function(){
            eventManager.broadcast('module:change:submodule', slug);
          }, 1000)
        },
        openMainMod: function(slug){
          eventManager.broadcast('module:change:meta',  'mtic_gr78_m_meta');
        }
      }

    }
  }
});